
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-program-software",
      function () {
        return require("private-next-pages/referral-program-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-program-software"])
      });
    }
  